import { responseStatus } from "../constants";
import { ApiPaths } from "../helpers/api";
import { dateCommon } from "../helpers/common";
import { NguoiDungResponse, TaiKhoanResponse } from "../models/nguoidung/NguoiDung";
import intance from "../utils/axios";

export const layThongTinCaNhan = async () => {
    var rs: NguoiDungResponse = {
        id: 0,
        tenDangNhap: "",
        hoTen: "",
        tenDonVi: "",
        idDonVi: 0,
        dienThoai: "",
        email: "",
        ngaySinh: new Date(),
        canCuocChungMinh: "",
        noiCap: "",
        ngayCap: new Date(),
        kichHoat: false,
        ngayKhoiTao: new Date(),
        isAdmin: false,
        tenChucVu: "",
        avatar: ""
    };
    await intance.get(ApiPaths.caNhan.layThongTin)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                var duLieu: any = res.data.duLieu;
                rs.id = duLieu?.id || 0;
                rs.tenDangNhap = duLieu?.tenDangNhap || "";
                rs.idDonVi = duLieu?.idDonVi || 0;
                rs.tenDonVi = duLieu?.tenDonVi || "";
                rs.hoTen = duLieu?.hoTen || "";
                rs.dienThoai = duLieu?.dienThoai || "";
                rs.email = duLieu?.email || "";
                rs.canCuocChungMinh = duLieu?.canCuocChungMinh || "";
                rs.noiCap = duLieu?.noiCap || "";
                rs.tenChucVu = duLieu?.tenChucVu || "";
                rs.ngaySinh = new Date(duLieu?.ngaySinh) || null;
                rs.ngayCap = new Date(duLieu?.ngayCap) || null;
                rs.kichHoat = duLieu?.kichHoat || 0;
                rs.avatar = duLieu.avatar || "";
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
};

export const luuThongTinCaNhan = async (data: any) => {
    let id = 0;
    await intance.post(ApiPaths.caNhan.luuThongTin, data)
        .then(res => {
            if (res.data.trangThai != responseStatus.thanhCong) {
                throw new Error(res.data.thongBao); 
            }
        })
        .catch(err => {
            throw err;
        });
    return id;
};

export const layChiTietNguoiDung = async (id: number) => {
    var rs: NguoiDungResponse = {
        id: 0,
        tenDangNhap: "",
        hoTen: "",
        tenDonVi: "",
        idDonVi: 0,
        dienThoai: "",
        email: "",
        ngaySinh: null,
        canCuocChungMinh: "",
        noiCap: "",
        ngayCap: null,
        kichHoat: false,
        ngayKhoiTao: new Date(),
        isAdmin: false,
        tenChucVu: "",
        avatar: ""
    };
    await intance.get(ApiPaths.nguoiDung.LayCTNguoiDung +"?id="+id)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                var duLieu: any = res.data.duLieu;
                rs.id = duLieu?.id || 0;
                rs.tenDangNhap = duLieu?.tenDangNhap || "";
                rs.idDonVi = duLieu?.idDonVi || 0;
                rs.tenDonVi = duLieu?.tenDonVi || "";
                rs.hoTen = duLieu?.hoTen || "";
                rs.dienThoai = duLieu?.dienThoai || "";
                rs.email = duLieu?.email || "";
                rs.canCuocChungMinh = duLieu?.canCuocChungMinh || "";
                rs.noiCap = duLieu?.noiCap || "";
                rs.tenChucVu = duLieu?.tenChucVu || "";
                rs.ngaySinh = dateCommon.getDateValue(duLieu?.ngaySinh);
                rs.ngayCap = dateCommon.getDateValue(duLieu?.ngayCap);
                rs.kichHoat = duLieu?.kichHoat || false;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
};

export const doimatKhau = async (data: any) => {
    await intance.post(ApiPaths.caNhan.doiMatKhau, data)
        .then(res => {
            if (res.data.trangThai != responseStatus.thanhCong) {
                throw new Error(res.data.thongBao); 
            }
        })
        .catch(err => {
            throw err;
        });
};

export const layDSTaiKhoanTheoIdNhanVien = async (idNhanVien: number) => {
    var data: Array<TaiKhoanResponse> = [];
    await intance.get(ApiPaths.nguoiDung.LayDSTaiKhoan + "?id=" + idNhanVien)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = res.data.duLieu;
            } else {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
};

export const xoaTaiKhoan = async (id: number) => {
    let rs = false
    await intance.post(ApiPaths.nguoiDung.xoaTaiKhoan + "?id=" + id)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                rs = true;
            }
        })
        .catch((error) => {
            throw error;
        })
    return rs;
}

export const themTaiKhoan = async (request: any) => {
    var response = { trangThai: responseStatus.loi };
    await intance.post(ApiPaths.nguoiDung.themTaiKhoan, request)
        .then(res => {
            response = res.data;
        })
        .catch(err => {
        });
    return response;
};

export const kichHoatTaiKhoan = async (id: number, kichHoat: boolean) => {
    const data = {
        idNguoiDung: id,
        kichHoat: kichHoat
    };

    await intance.post(ApiPaths.nguoiDung.kichHoatTaiKhoan, data)
        .then(res => {
            if (res.data.trangThai != responseStatus.thanhCong) {
                throw new Error(res.data.thongBao);
            }
        })
        .catch(err => {
            throw err;
        });
};

export const datLaiMatKhau = async (idNguoiDung: number) => {
    let matKhauMoi = "";
    await intance.post(ApiPaths.nguoiDung.datLaiMatKhau + "?idNguoiDung=" + idNguoiDung)
        .then(res => {
            if (res.data.trangThai != responseStatus.thanhCong) {
                throw new Error(res.data.thongBao);
            }
            else {
                matKhauMoi = res.data.duLieu;
            }
        })
        .catch(err => {
            throw err;
        });
    return matKhauMoi;
};

export const quenMatKhau = async (email: string, userName: string) => {
    var rs = false;
    await intance.post(ApiPaths.nguoiDung.quenMatKhau + "?email=" + email + "&userName=" + userName)
        .then(res => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = true;
            }
        })
        .catch(err => {
            throw err;
        });

    return rs;
};
